export const CLARITY_ATTRIBUTE_NAME = 'data-clarity-mask';
export const CLARITY_ATTRIBUTE_VALUE = 'True';

export const MASKING_PROPS = {
  [CLARITY_ATTRIBUTE_NAME]: CLARITY_ATTRIBUTE_VALUE,
};
